import { FormControl, FormHelperText } from "@chakra-ui/react";
import { useState } from "react";
import Select from "react-select";

export default function CustomSelect({
  options,
  isClearable = true,
  isSearchable = true,
  isLoading = false,
  width = "100%",
  name,
  label = "",
  className = "customScrollBar",
  customStyles,
  isMulti = false,
  minH,
  onChange,
  ...props
}: any) {
  const defaultStyles = {
    control: (provided: any) => ({
      ...provided,
      "min-height": minH,
      "max-height": "58px",
      backgroundColor: "white",
      borderColor: "#3b82f6", // teal.400
      width: width,
      boxShadow: "none",
      "&:hover": {
        borderColor: "#376ecf",
      },
      overflow: "auto",
    }),
    option: (provided: any, state: { isSelected: any }) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#376ecf" : "white",
      color: state.isSelected ? "white" : "black",
      "&:hover": {
        backgroundColor: "#3b82f6",
        color: "white",
      },
      cursor: "pointer",
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#376ecf", // Teal color for selected value
      fontWeight: "500",
    }),
    menuList: (provided: any) => ({
      ...provided,
      maxHeight: 260,
      overflowY: "auto",
      position: "relative", // Add this line to make the menuList position relative
      "&::-webkit-scrollbar": {
        width: "4px",
        height: "10px",
      },
      "&::-webkit-scrollbar-track": {
        // background: "#f1f1f1",
        boxShadow: "inset 0 0 5px grey",
        borderRadius: "10px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#325ba9",
        borderRadius: "10px",
      },
    }),
    menu: (provided: any) => ({
      ...provided,
      position: "absolute", // Make the menu position absolute
      width: "100%", // Set the width to 100% to match the control
      zIndex: 9999, // Set a higher z-index to make it appear on top
    }),
    // clearIndicator: (provided: any) => ({
    //   ...provided,
    //   position: "absolute", // Make the clearIndicator position absolute
    //   top: "10px",
    //   right: "12px",
    //   transform: "translateY(-50%)", // Center it vertically
    // }),
  };
  const [selectedValue, setSelectedValue] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  return (
    <FormControl id="select" variant="floating">
      <Select
        placeholder={""}
        classNamePrefix="select"
        isClearable={isClearable}
        isSearchable={isSearchable}
        isLoading={isLoading}
        name={name}
        isMulti={isMulti}
        options={options}
        styles={defaultStyles}
        value={selectedValue}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        onChange={(value: any) => {
          setSelectedValue(value);
          if (onChange) {
            onChange(value);
          }
        }}
        {...props}
      />
      <FormHelperText
        style={{
          position: "absolute",
          zIndex: 2,
          backgroundColor: "white",
          left: "20px",
          fontSize: "14px",
          fontWeight: "500",
          top: selectedValue || isFocused ? "-18px" : "30%",
          transition: "top 0.3s",
          transform: selectedValue || isFocused ? "none" : "translateY(-50%)",
        }}
      >
        {label}
      </FormHelperText>
    </FormControl>
  );
}
